// instead of a union type to make isSupportedVersion self-maintained
const SUPPORTED_VERSIONS = [
  'v1',
  'v2',
  'v3',
  'v4',
  'v5',
  'v6',
  'v7',
  'v8',
  'v9',
  'v10',
  'v11',
  'v12',
  'v13',
] as const;
export type SupportedVersions = (typeof SUPPORTED_VERSIONS)[number];

export const isSupportedVersion = (
  version: string
): version is SupportedVersions =>
  SUPPORTED_VERSIONS.includes(version as SupportedVersions);
